export default __webpack_public_path__ + "assets/images/d21425052e8de792821baa8755f7d4bb.jpg";